import * as tagColor from './CountTag.module.scss';
import { CountTag } from './CountTag';
import { isNumber } from '@sonar-software/sonar-ts-lib';
import { PercentageOutlined } from '@ant-design/icons';
import React from 'react';
export const PopulationPercentageTag = ({ parentName, percent }) => React.createElement(CountTag, { color: tagColor.populationPercentage, count: percent !== null && percent !== void 0 ? percent : undefined, icon: React.createElement(PercentageOutlined, null), tooltip: `This field is populated on ${percent}% of ${parentName} records.`, visible: isNumber(percent) });
